import { CheckCircle2, AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";

export const RECORDERS = ["admin", "regional_manager", "community_manager"];
export const ACCEPT = ".pdf,.jpg,.jpeg,.png,.heic";
export const MAX_MB = 20;
export const inputCls = "h-10 w-full rounded-full border border-lasso-line bg-white px-4 text-sm focus:border-lasso-ink focus:outline-none";

export const RecordStatus = ({ status, missing = [], testId }) => status === "complete" ? (
  <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-0.5 text-[11px] font-semibold text-emerald-700" data-testid={testId}><CheckCircle2 className="h-3.5 w-3.5" /> Complete</span>
) : (
  <span className="inline-flex items-center gap-1 rounded-full bg-amber-50 px-2.5 py-0.5 text-[11px] font-semibold text-amber-800" title={missing.join(", ")} data-testid={testId}><AlertTriangle className="h-3.5 w-3.5" /> Missing forms</span>
);

export async function fileBlobUrl(recordId, fileId) {
  const { data } = await api.get(`/form-records/${recordId}/files/${fileId}`, { responseType: "blob" });
  return URL.createObjectURL(data);
}
